import { AccordionDetails, Stack } from '@mui/material';
import { ReactNode } from 'react';
import { DynamicIcon } from 'src/components/DynamicIcon/dynamic-icon';
import {
  FlatAccordion,
  FlatAccordionSummary,
} from 'src/components/FlatAccordion/flat-accordion';
import { SidePanelCaption } from 'src/components/SidePanelCaption';
import useCustomAttributesUIStore from 'src/store/custom-attributes-ui';

interface CollapsibleGroupProps {
  scopeKey: string;
  groupKey: string;
  label: string;
  children: ReactNode;
}

export const CollapsibleGroup = ({
  scopeKey,
  groupKey,
  label,
  children,
}: CollapsibleGroupProps) => {
  const collapsed = useCustomAttributesUIStore((s) =>
    (s.collapsedGroupsByScope[scopeKey] ?? []).includes(groupKey),
  );
  const setGroupCollapsed = useCustomAttributesUIStore((s) => s.setGroupCollapsed);

  return (
    <FlatAccordion
      expanded={!collapsed}
      onChange={(_, expanded) => setGroupCollapsed(scopeKey, groupKey, !expanded)}
      disableGutters
    >
      <FlatAccordionSummary
        expandIcon={<DynamicIcon name="chevron-down" library="lucide" />}
        sx={{ px: 0 }}
      >
        <SidePanelCaption sx={{ alignSelf: 'center' }}>{label}</SidePanelCaption>
      </FlatAccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <Stack>{children}</Stack>
      </AccordionDetails>
    </FlatAccordion>
  );
};
